export enum CHEATTYPE {
  /** 中途离开 */
  LEAVE = 'LEAVE',
  /** 截屏 */
  SCREEN_SHOT = 'SCREEN_SHOT',

  /** 提交 */
  SUBMIT = 'SUBMIT',
  /** 超时交卷 */
  OVERTIME_SUBMIT = 'OVERTIME_SUBMIT',

  /** 合规异常 */
  NOT_COMPLIANT = 'NOT_COMPLIANT',

  /** 特征库对比 */
  FEATURE_COMPARE = 'FEATURE_COMPARE',
  /** 声纹特征异常 */
  FEATURE_ERROR_OF_AUDIO = 'FEATURE_ERROR_OF_AUDIO',
  /** 图像特征异常 */
  FEATURE_ERROR_OF_IMG = 'FEATURE_ERROR_OF_IMG',

  /** 视频图像异常 */
  FEATURE_ERROR_OF_VIDEO = 'FEATURE_ERROR_OF_VIDEO',
  /** 转头检测 */
  TURN_HEAD = 'TURN_HEAD',
  /** 无人检测 */
  NONE_PERSON = 'NONE_PERSON',
  /** 多人检测 */
  MULTI_PERSON = 'MULTI_PERSON',
  /** 视频换人 */
  CHANGE_PERSON = 'CHANGE_PERSON',
  /** 视频质量未达标 */
  VIDEO_QUALITY_TOO_LOW = 'VIDEO_QUALITY_TOO_LOW',
  /** 一人分饰两角 */
  ONE_PLAY_TWO_ROLE = 'ONE_PLAY_TWO_ROLE',
  /** 睁眼作答 */
  OPEN_EYES = 'OPEN_EYES',
  /** 未张嘴作答 */
  NOT_OPEN_MOUTH = 'NOT_OPEN_MOUTH',

  /** 语种判定异常 */
  LANGUAGE_RESTRICT = 'LANGUAGE_RESTRICT',
  /** 有效作答异常 */
  EFFECT_ANSWER = 'EFFECT_ANSWER',
  /** 内容重复 */
  CONTENT_REPEAT = 'CONTENT_REPEAT',

  /** 不需要检查 */
  NONE = 'NONE',
  /** 未检查 */
  UN_CHECK = 'UN_CHECK',
  /** 不相似的 */
  NOT_SIMILAR = 'NOT_SIMILAR'
}

export enum FACTORS {
  TIME = 'TIME', // 时间
  DEGREE = 'DEGREE', // 角度
  AUDIO = 'AUDIO', // 音频
  IMG = 'IMG' // 图像
}

export const CHEATTYPENAME = {
  [CHEATTYPE.LEAVE]: '中途离开',
  [CHEATTYPE.SCREEN_SHOT]: '截屏',
  [CHEATTYPE.FEATURE_COMPARE]: '特征不符合',
  [CHEATTYPE.FEATURE_ERROR_OF_AUDIO]: '声纹特征异常',
  [CHEATTYPE.NONE_PERSON]: '视频无人',
  [CHEATTYPE.MULTI_PERSON]: '视频多人',
  [CHEATTYPE.CHANGE_PERSON]: '视频换人',
  [CHEATTYPE.VIDEO_QUALITY_TOO_LOW]: '视频质量未达标，不进行画面内容分析', // 视频质量未达标，不进行画面内容分析
  [CHEATTYPE.OPEN_EYES]: '睁眼作答',
  [CHEATTYPE.NOT_COMPLIANT]: '合规异常',
  [CHEATTYPE.TURN_HEAD]: '转头',
  [CHEATTYPE.LANGUAGE_RESTRICT]: '语种判定异常',
  [CHEATTYPE.EFFECT_ANSWER]: '有效作答异常',
  [CHEATTYPE.CONTENT_REPEAT]: '内容重复',
  [CHEATTYPE.ONE_PLAY_TWO_ROLE]: '一人分饰两角',
  [CHEATTYPE.FEATURE_ERROR_OF_IMG]: '图像特征异常',
  [CHEATTYPE.SUBMIT]: '提交',
  [CHEATTYPE.OVERTIME_SUBMIT]: '超时交卷',
  [CHEATTYPE.NOT_OPEN_MOUTH]: '作答过程中，答题人未张嘴作答'
};

// 默认两条规则，用于前端显示
export const initialRules = [
  {
    type: CHEATTYPE.LEAVE,
    factor: FACTORS.TIME
  },
  {
    type: CHEATTYPE.SCREEN_SHOT
  }
];
